import api from "./axiosConfig";
import { NotificationDeliveryHistoryViewModel } from "./generated/models/NotificationDeliveryHistoryViewModel";

// The generated client predates these backend additions; regenerate with
// `npm run generate:api` once the backend is deployed and drop the overrides.

/** Delivery history rows carry an id since the conversion-tracking backend release. */
export type NotificationDeliveryHistoryRow = NotificationDeliveryHistoryViewModel & {
  id?: string | null;
};

export interface NotificationDeliveryConversionViewModel {
  recipientsCount: number;
  convertedCount: number;
  convertedWithin7DaysCount: number;
  convertedWithin30DaysCount: number;
  sentAt: string | null;
}

export const getNotificationDeliveryConversionForAdmin = async (
  notificationDeliveryHistoryId: string
): Promise<NotificationDeliveryConversionViewModel> => {
  try {
    const response = await api.post<NotificationDeliveryConversionViewModel>(
      "/notification/get-notification-delivery-conversion-for-admin",
      { notificationDeliveryHistoryId }
    );
    return response.data;
  } catch (error) {
    console.error("Getting notification delivery conversion error:", error);
    throw error;
  }
};
